"use client";

import { cn } from "@nyntax/design-system/lib/utils";
import type { ReactNode } from "react";
import { useDataTable } from "./data-table-context";

interface DataTableFooterProps {
  children: ReactNode;
  className?: string;
}

function DataTableFooter({ children, className }: DataTableFooterProps) {
  const table = useDataTable();
  const rowCount = table.getRowCount();

  const noRows = rowCount === 0;
  const MaxRowsPerPage = 13;
  const hasReachedMaxRows = rowCount === MaxRowsPerPage;

  if (noRows) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex w-full flex-col items-center justify-between gap-4 px-4 pt-2.5 md:flex-row md:gap-2",
        { "pb-2.5": !hasReachedMaxRows },
        className
      )}
    >
      {children}
    </div>
  );
}

export type { DataTableFooterProps };
export { DataTableFooter };
